(function(){
  function ready(fn){ if(document.readyState!='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function(){
    // hilo dorado + fill según scroll
    var fill=document.getElementById('dqThreadFill'), bead=document.getElementById('dqThreadBead');
    function onScroll(){
      var max=document.documentElement.scrollHeight-window.innerHeight;
      var pct=max>0?Math.min(100,(window.scrollY/max)*100):0;
      if(fill) fill.style.height=pct+'%';
      if(bead) bead.style.top=pct+'%';
    }
    window.addEventListener('scroll',onScroll,{passive:true}); onScroll();

    // reveal on scroll
    var reveals=document.querySelectorAll('.dq-reveal');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('dq-visible');io.unobserve(e.target);}});},{threshold:.15});
      reveals.forEach(function(el){io.observe(el);});
    } else { reveals.forEach(function(el){el.classList.add('dq-visible');}); }

    // swatches de color en tarjetas de producto: pintan la bolita según el nombre de la variante
    // y muestran una vista previa de la imagen de esa variante al pasar el cursor / tocar
    var DQ_COLOR_MAP = {
      'dorado':'#C9A227','oro':'#C9A227','gold':'#C9A227','baño de oro':'#C9A227','oro amarillo':'#D4AF37',
      'oro rosa':'#E8B4A0','rose gold':'#E8B4A0','rosa gold':'#E8B4A0',
      'plateado':'#C7C7CC','plata':'#C7C7CC','silver':'#C7C7CC','acero':'#B7BAC0','acero inoxidable':'#B7BAC0',
      'bicolor':'linear-gradient(90deg,#C9A227 50%,#C7C7CC 50%)',
      'negro':'#22201d','black':'#22201d','onix':'#1c1a18',
      'blanco':'#F5F3EE','white':'#F5F3EE','perla':'#F1EAE0','perlado':'#F1EAE0',
      'rosa':'#F3C9CE','pink':'#F3C9CE','rosa pastel':'#F9D6D6','blush':'#F9D6D6',
      'rojo':'#A6362F','red':'#A6362F','coral':'#E37B5B',
      'azul':'#3E5C76','blue':'#3E5C76','turquesa':'#3FA7A0','celeste':'#A9D0DE',
      'verde':'#5B7B5A','green':'#5B7B5A','esmeralda':'#2E6B4F','oliva':'#7C7A4A',
      'morado':'#7A5C8E','purpura':'#7A5C8E','violeta':'#8E7BAE','lila':'#C9B6DE',
      'transparente':'#E9E5DC','cristal':'#E9E5DC','multicolor':'linear-gradient(90deg,#C9A227,#A6362F,#3E5C76)',
      'cafe':'#6B4A2E','marron':'#6B4A2E','beige':'#D8CBB4','gris':'#9A968E'
    };
    function dqColorFor(name){
      var key = (name||'').toLowerCase().trim();
      if(DQ_COLOR_MAP[key]) return DQ_COLOR_MAP[key];
      // coincidencia parcial (ej. "Plateado Mate" -> "plateado")
      for(var k in DQ_COLOR_MAP){ if(key.indexOf(k) !== -1) return DQ_COLOR_MAP[k]; }
      return null;
    }
    document.querySelectorAll('[data-dq-swatches]').forEach(function(wrap){
      var imgId = wrap.getAttribute('data-dq-card-image-id');
      var img = imgId ? document.getElementById(imgId) : null;
      var original = img ? (img.getAttribute('data-dq-original-src') || img.currentSrc || img.src) : null;
      var revertTimer;
      wrap.querySelectorAll('[data-dq-swatch]').forEach(function(sw){
        var color = dqColorFor(sw.getAttribute('data-swatch-name'));
        if(color) sw.style.setProperty('--swatch-color', color);
        var previewSrc = sw.getAttribute('data-image');
        var showPreview = function(){
          if(!img || !previewSrc) return;
          clearTimeout(revertTimer);
          img.classList.add('dq-fading');
          setTimeout(function(){ img.src = previewSrc; img.classList.remove('dq-fading'); }, 90);
        };
        var revertPreview = function(){
          if(!img || !original) return;
          img.classList.add('dq-fading');
          setTimeout(function(){ img.src = original; img.classList.remove('dq-fading'); }, 90);
        };
        sw.addEventListener('mouseenter', showPreview);
        sw.addEventListener('mouseleave', revertPreview);
        sw.addEventListener('focus', showPreview);
        sw.addEventListener('blur', revertPreview);
        sw.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          wrap.querySelectorAll('.dq-swatch').forEach(function(s){ s.classList.remove('is-active'); });
          sw.classList.add('is-active');
          showPreview();
          clearTimeout(revertTimer);
          revertTimer = setTimeout(revertPreview, 3500); // en touch, regresa sola tras unos segundos
        });
      });
    });

    // nudge automático y sutil en carruseles horizontales (ej. reseñas), solo para insinuar que se puede scrollear
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-dq-autoscroll]').forEach(function(track){
      if(prefersReduced) return;
      var done = false;
      var nudge = function(){
        if(done) return; done = true;
        if(track.scrollWidth <= track.clientWidth + 4) return; // no hay nada que scrollear
        track.scrollTo({left: 110, behavior: 'smooth'});
        setTimeout(function(){ track.scrollTo({left: 0, behavior: 'smooth'}); }, 900);
      };
      // se cancela si la persona ya interactúa a mano
      ['pointerdown','wheel','touchstart'].forEach(function(evt){
        track.addEventListener(evt, function(){ done = true; }, {passive:true, once:true});
      });
      if('IntersectionObserver' in window){
        var ioNudge = new IntersectionObserver(function(es){
          es.forEach(function(e){ if(e.isIntersecting){ setTimeout(nudge, 500); ioNudge.disconnect(); } });
        }, {threshold:.6});
        ioNudge.observe(track);
      } else { setTimeout(nudge, 800); }
    });

    // carruseles (pueden ser varios)
    document.querySelectorAll('[data-dq-carousel]').forEach(function(wrap){
      var track=wrap.querySelector('.dq-carousel');
      var prev=wrap.querySelector('[data-dq-prev]'), next=wrap.querySelector('[data-dq-next]');
      if(prev) prev.addEventListener('click',function(){track.scrollBy({left:-320,behavior:'smooth'});});
      if(next) next.addEventListener('click',function(){track.scrollBy({left:320,behavior:'smooth'});});
    });

    // pop-up de descuento (solo en HOME, una vez por sesión)
    var dm=document.getElementById('dqDiscountModal');
    if(dm){
      var isHome = window.location.pathname === '/' || window.location.pathname === '';
      if(!isHome){ dm.style.display='none'; } else {
        var seen=false; try{seen=sessionStorage.getItem('dqDiscountSeen');}catch(e){}
        var openD=function(){dm.classList.add('open');};
        var closeD=function(){dm.classList.remove('open');try{sessionStorage.setItem('dqDiscountSeen','1');}catch(e){}};
        if(!seen && !window.Shopify?.designMode) setTimeout(openD,2200);
        if(window.Shopify?.designMode) openD();
        var dc=document.getElementById('dqDiscountClose'), ds=document.getElementById('dqDiscountSkip');
        if(dc) dc.addEventListener('click',closeD);
        if(ds) ds.addEventListener('click',closeD);
        dm.addEventListener('click',function(e){if(e.target===dm)closeD();});
      }
    }

    // modal login
    var lm=document.getElementById('dqLoginModal');
    if(lm){
      var openL=function(e){if(e)e.preventDefault();lm.classList.add('open');};
      var closeL=function(){lm.classList.remove('open');};
      document.querySelectorAll('[data-dq-login-open]').forEach(function(b){b.addEventListener('click',openL);});
      var lc=document.getElementById('dqLoginClose'), gb=document.getElementById('dqGuestBtn');
      if(lc) lc.addEventListener('click',closeL);
      if(gb) gb.addEventListener('click',closeL);
      lm.addEventListener('click',function(e){if(e.target===lm)closeL();});
    }
  });
})();
